import { Instance, SnapshotOut, types } from "mobx-state-tree"
import {BusinessStoreModel} from "../business-store/business-store";
import {AuthStoreModel} from "../auth-store/auth-store";
import {ProjectStoreModel} from "../project-store/project-store";
import {ActionStoreModel} from "../action-store/action-store";
import {StaffStoreModel} from "../staff-store/staff-store";

/**
 * A RootStore model.
 */
// prettier-ignore
export const RootStoreModel = types.model("RootStore").props({
  businessStore: types.optional(BusinessStoreModel, {} as any),
  authStore: types.optional(AuthStoreModel, {} as any),
  projectStore: types.optional(ProjectStoreModel, {} as any),
  actionStore: types.optional(ActionStoreModel, {} as any),
  staffStore: types.optional(StaffStoreModel, {} as any)
})

/**
 * The RootStore instance.
 */
export interface RootStore extends Instance<typeof RootStoreModel> {}

/**
 * The data of a RootStore.
 */
export interface RootStoreSnapshot extends SnapshotOut<typeof RootStoreModel> {}
